(function ($) {
    $(function () {

           
    
            
        if($('#Slider-Thumbnails-template--16629696954604__main').length){
            $('#Slider-Thumbnails-template--16629696954604__main').slick({
                dots: false,
                arrows:false,
                autoplay:false,
                autoplaySpeed:5000,
                infinite: false,
                speed: 300,
                slidesToShow:7,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow:5,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow:3,
                        }
                    },
                ]
            });
            }
            $(window).on('resize', function () {       
                $('#Slider-Thumbnails-template--16629696954604__main').slick('resize'); 

            });

        $(window).scroll(function() {    
          var scroll = $(window).scrollTop();
      
          if (scroll >= 1200) {
              $("body").addClass("add-to-cart-fixed");
          } else {
              $("body").removeClass("add-to-cart-fixed");
          }
        });

            
        

    }) // End ready function.

})(jQuery)